module.exports = ".spinner {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  color: #f6a800;\n  background: rgba(255, 255, 255, 0.75);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.scss
// module id = ./src/app/shared/spinner/spinner.component.scss
// module chunks = main